import { isUnionOf, is } from "./type-guards.js";
export const isNullish = isUnionOf(is("null"), is("undefined"));
export const assertIsNotNullish = (candidate, message) => {
    if (isNullish(candidate)) {
        throw new TypeError(message ?? `Encountered unexpected ${String(candidate)}.`);
    }
};
//# sourceMappingURL=pre-built.js.map